import { render } from "./Footer.vue?vue&type=template&id=1f3611de&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=1f3611de&scoped=true&lang=css"

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3611de"]])

export default __exports__